<template>
  <div class="alert-modal-container">
    <div class="main-content">
      <div class="alert-message">
        <p>{{ deleteMessage }}</p>
      </div>
      <div class="alert-modal-btn">
        <button class="btn-ok" @click="closeModal('ok')">Ok</button>
        <button class="btn-cancel" @click="closeModal('cancel')">Cancel</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      deleteMessage: {
        type: String,
        default: ''
      }
    },
    data() {
      return {

      };
    },
    methods: {
      closeModal(val) {
        this.$emit('closeModal',val);
      }
    }
  };
</script>
